import { render, staticRenderFns } from "./LastDisaster.vue?vue&type=template&id=b8861c8c&"
import script from "./LastDisaster.vue?vue&type=script&lang=js&"
export * from "./LastDisaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports